import React from 'react';
import { Badge } from './ui/badge';
import { STATUS_LABELS, STATUS_COLORS, REQUEST_STATUS_COLORS } from '../lib/format';

export const StatusBadge = ({ status, type = 'equipment' }) => {
  if (!status) return <Badge variant="outline">—</Badge>;
  const s = String(status).toLowerCase();
  const palette = type === 'equipment' ? STATUS_COLORS : REQUEST_STATUS_COLORS;
  const label = type === 'equipment' ? (STATUS_LABELS[s] || status) : (s.charAt(0).toUpperCase() + s.slice(1).replace('_', ' '));
  const cls = palette[s] || 'bg-slate-100 text-slate-700 border-slate-200';
  return <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${cls}`}>{label}</span>;
};

export default StatusBadge;
